export const iconFontAwesomeLogisticsHelmetSafety = (
	<i className="fa-solid fa-helmet-safety"></i>
);
